import "./Advertise.css";
import { Helmet } from "react-helmet-async";

const Advertise = ({ dark }) => {
  return (
    <div className={`advertise-page ${dark ? "dark" : "light"}`}>
      <Helmet>
        <title>Advertise With FadaSports - Reach Sports Audiences</title>
        <meta name="description" content="Partner with FadaSports to reach highly engaged sports audiences. Advertising opportunities, sponsorships, and brand partnerships available." />
        <meta name="keywords" content="advertise, advertising, sports advertising, sponsorships, brand partnership, sports marketing" />
        <meta name="author" content="FadaSports" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Advertise With FadaSports" />
        <meta property="og:description" content="Reach sports fans through FadaSports advertising and partnership opportunities." />
        <meta property="og:image" content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="FadaSports" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@FadaSports" />
      </Helmet>
      
      <section className="advertise-hero">
        <div className="advertise-overlay">
          
          <h1>Advertise With Us</h1>

          <p>
            Reach a highly engaged sports audience on FadaSports.
          </p>

        </div>
      </section>

      <section className="advertise-content">

        <div className="advertise-card">

          <h2>Partner With FadaSports</h2>

          <p>
            If you are interested in promoting your brand, product, or
            service on our platform, we offer advertising and partnership
            opportunities across our sports content, statistics, and media
            ecosystem.
          </p>

          <p>
            FadaSports connects brands with passionate sports audiences
            through premium sports coverage, football analysis, live
            statistics, editorial content, and digital fan engagement.
          </p>

          <p>
            Whether you are looking to increase visibility, promote a
            campaign, launch a product, or build long-term sports
            partnerships, our platform provides opportunities to reach
            dedicated fans across multiple devices and experiences.
          </p>

          <div className="advertise-box">

            <h3>Advertising Opportunities</h3>

            <ul>
              <li>⚽ Sponsored sports content</li>
              <li>📊 Brand visibility across statistics pages</li>
              <li>📰 Display advertising placements</li>
              <li>🎥 Video and media partnerships</li>
              <li>📱 Mobile and desktop campaigns</li>
              <li>🏆 Competition and event sponsorships</li>
            </ul>

          </div>

          <div className="contact-box">

            <h3>Get Started</h3>

            <p>
              To get started, send us an email at:
            </p>

            <a href="mailto:adverts@fadasports.com">
              adverts@fadasports.com
            </a>

            <p className="small-text">
              Our team will respond with available options and next steps.
            </p>

          </div>

        </div>

      </section>

    </div>
  );
};

export default Advertise;